import React from 'react';
import SeeAllButton from './SeeAllButton';

interface SectionProps {
  title: string;
  onSeeAll?: () => void;
  children: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({ title, onSeeAll, children }) => {
  return (
    <section className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-white">{title}</h2>
        {onSeeAll && (
          <SeeAllButton onClick={onSeeAll}>
            See all
          </SeeAllButton>
        )}
      </div>
      <div>{children}</div>
    </section>
  );
};

export default Section;
